import { PartialSubset } from '@upr-web-primer/app-utils';
import { cloneDeep, merge } from 'lodash-es';
import { shared_environment } from './environment.shared';
import { udeploy } from './udeploy';

const overwrite: PartialSubset<typeof shared_environment> = {
  commerceApi: 'occ/v2/b2cportal_ush',
  config: {
    // prettier-ignore
    createAccount: {
      links:
        '[{\"tridionKey\":\"createAccount.Terms\",\"linkURL\":\"createAccount.termsLink\",\"target\":\"_blank\",\"altText\":\"createAccount.termsAltText\"},{\"tridionKey\":\"createAccount.privacyPolicy\",\"linkURL\":\"createAccount.privacyLink\",\"target\":\"_blank\",\"altText\":\"createAccount.privacyPolicyAltText\"},{\"tridionKey\":\"createAccount.informationcenter\",\"linkURL\":\"createAccount.infoLink\",\"target\":\"_blank\",\"altText\":\"createAccount.informationcenterAltText\"}]',
      checkboxes:
        '[{\"tridionKey\":\"createAccount.agree\",\"defaultValue\":false,\"required\":true,\"id\":\"termCondition\",\"altText\":\"createAccount.agreeAltText\"},{\"tridionKey\":\"createAccount.specialOffers\",\"defaultValue\":true,\"required\":false,\"id\":\"specialOffer\",\"altText\":\"createAccount.specialOffersAltText\"}]',
    },
    dashboard: {
      showDiningReservationLink: true,
      showBuyTicketsLink: true,
      showLinkTicketsLink: true,
      showTicketContent: true,
      isNavigate: true,
      matchIconByUrl: true,
    },
    showPriority: true,
    displayFirstNameFirst: true,
    deletingUSHAccount: true,
    isV1_1FeatureEnabled: true,
  },
  gds_footer: {
    content_id: 'GDS-Footer-Utility-USH-ACCOUNT',
  },
  tridion: {
    publication: 'ush',
  },
  contentIds: {
    GDS_GLOBAL_NAV_UTILITY_BAR_CONTENT_ID: 'GDS-Main-Nav-Utility-USH-ACCOUNT',
    GDS_GLOBAL_NAV_MEGA_NAV_CONTENT_ID:
      'gds-global-nav-ush-mega-nav-main-account',
  },
  displayDateByTimezone: true,
  entitlementDataUrl:
    '/guests/{guestId}/guest-travel-party-member-tickets?resort-area-code={code}&embed=Lineage',
  faviconUrl: 'assets/favicons/ush-favicon.ico',
  fetchTravelPartyUrl: '/guests/{guestId}/travel-party-members',
  hideScanIconDesktop: true,
  isMMDDYYYYFormat: true,
  oneTrustHash:
    'sha384-TKdmlzVmoD70HzftTw4WtOzIBL5mNx8mXSRzEvwrWjpIJ7FZ/EuX758yMDWXtRUN',
  pageLabelsUrl: '/resort-areas/ush/content-labels',
  resortAreaCode: 'USH',
  resortName: 'USH',
  sap_cart: {
    base_site: 'b2cportal_ush',
  },
  sendParamsTravelParty: true,
  shareQrEntitlementsAvailable: true,
  showCommPrefCard: true,
  showCreditCardDetails: true,
  showGalaxyTickets: true,
  SourceIdKey: {
    en: {
      WebAccountCreation: '1012000',
      WebEditCommunications: '1012004',
      WebEditContactInfo: '1012005',
      WebEditPersonalInfo: '1012006',
      WebEditAddress: '1012007',
      WebCreateorEditProfileTravelParty: '1018004',
      WebLinkEntitlements: '1012029',
      WebUpdatePassword: '1012063',
      WebPaymentCard: '1012025',
      WebAccountDelete: '1032024',
    },
    ja: {
      WebAccountCreation: '1012000',
      WebEditCommunications: '1012004',
      WebEditPersonalInfo: '1012006',
      WebEditAddress: '1012007',
      WebCreateorEditProfileTravelParty: '1012024',
      WebLinkEntitlements: '1012029',
      WebUpdatePassword: '1012063',
      WebPaymentCard: '1012025',
      WebAccountDelete: '1032024',
    },
  },
  specialOffers: true,
  showPaymentCard: true,
  showTax: true,
  tridionSite: 'ush',
  baseSite: 'b2cportal_ush',
  linkEntitlement: '/guests/{guest-id}/link-ticket',
  DINING_RESERVATION:
    'https://www.universalstudioshollywood.com/dining/en/us/dashboard',
};
const initial_env = merge(shared_environment, overwrite);
export const ush_shared_environment_local = initial_env;
export const ush_shared_environment = merge(cloneDeep(initial_env), udeploy);
